import React from "react";

import classNames from "classnames";

import type { JSX } from "react";

interface HighlightTypeProps {
  icon: JSX.Element;
  title: string;
  onChange: () => void;
  isSelected: boolean;
  isDisabled?: boolean;
}

function HighlightType({
  icon,
  title,
  onChange,
  isSelected,
  isDisabled,
}: HighlightTypeProps): JSX.Element {
  const containerClassName = classNames(
    "m-[0.625rem] flex flex-col items-center gap-[0.15625rem]",
    isDisabled ? "opacity-50 cursor-not-allowed " : "cursor-pointer",
  );
  const iconClassName = classNames(
    "flex size-[3.75rem] items-center justify-center rounded-full",
    {
      "bg-primary text-primary-foreground": isSelected,
      "bg-surface-muted text-muted-foreground": !isSelected,
    },
  );
  const titleClassName = classNames(
    "text-[0.9375rem] font-semibold text-muted-foreground",
    isSelected && "text-primary",
  );

  return (
    <div className={containerClassName} onClick={onChange}>
      <div className={iconClassName}>{icon}</div>
      <span className={titleClassName}>{title}</span>
    </div>
  );
}
export default HighlightType;
